"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ng_qmap_1 = require("ng-qmap");
const _4d_mapper_1 = require("4d-mapper");
const operators_1 = require("rxjs/operators");
class VasatQMAPService extends ng_qmap_1.QMAPService {
    constructor(fourD) {
        super();
        this.fourD = fourD;
    }
    objectTypeQMap(objString) {
        return [{ id: 'name', type: 'shorttext', title: 'Name', required: true }];
    }
    objectsForQMap(qMap, searchString, superModel) {
        var query = this.fourD.V.searchByObject(this.fourD.V.registeredClassForString(qMap.obj_type));
        if (searchString)
            query = query.contains('name', searchString);
        return query.queryObservable().pipe(operators_1.map(i => i.items));
    }
    isModel(obj) {
        return !!obj && obj.toJSON;
    }
    findCachedModel(qmap, id) {
        return this.fourD.V.findCached(qmap.obj_type, id);
    }
    makeModel(qmap) {
        var clazz = this.fourD.V.registeredClassForString(qmap.obj_type);
        return new clazz(this.fourD.V);
    }
    canWrite(sm) {
        return sm.permissions ? sm.permissions.find(p => 'api_update') : true;
    }
    canDelete(sm) {
        return sm.permissions ? sm.permissions.find(p => 'api_delete') : false;
    }
    absURL(m, s) {
        return m.file(s) + '?access_token=' + this.fourD.V.token;
    }
}
exports.VasatQMAPService = VasatQMAPService;
